'use client'
import { ContainerCustom, Icon } from '@/components'
import { MENU_MOBILE } from '@/config/global-config'
import { PopupFormOrderLookup } from '@/features/orders/components/order-lookup/popup-form'
import { usePathname } from '@/libs/i18n/routing'
import MenuIcon from '@mui/icons-material/Menu'
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { Logo } from '../../v1/components'
import MegaMenuMainBar from './mega-menu-main-bar'

const NavMenuMobile = dynamic(() => import('./NavMenuMobile'), {
  ssr: false,
  loading: () => (
    <IconButton aria-label="Menu" sx={{ mr: 1, p: 0, display: { xs: 'block', lg: 'none' } }}>
      <MenuIcon sx={{ color: '#252422' }} />
    </IconButton>
  ),
})

const CartHeader = dynamic(() => import('./cart').then((mod) => mod.CartHeader), {
  ssr: false,
  loading: () => (
    <IconButton
      aria-label="Giỏ hàng"
      sx={{
        width: 'var(--size-hd-icon)',
        height: 'var(--size-hd-icon)',
      }}
    >
      <Icon.Bag sx={{ fontSize: '1.2rem', color: 'primary.main' }} />
    </IconButton>
  ),
})

const UserLogin = dynamic(() => import('./user-login').then((mod) => mod.UserLogin), {
  ssr: false,
  loading: () => (
    <IconButton
      aria-label="Tài khoản"
      sx={{
        width: 'var(--size-hd-icon)',
        height: 'var(--size-hd-icon)',
      }}
    >
      <Icon.UserV2 sx={{ fontSize: '1.2rem' }} />
    </IconButton>
  ),
})
interface MenuItem {
  title: (t: (key: string) => string) => string
  href: string
  isCommingSoon?: boolean
  hasMegaMenu?: boolean
}
const LEFT_MENU_ITEMS: MenuItem[] = [
  {
    title: (t: (key: string) => string) => t('CỬA HÀNG'),
    href: '/danh-muc-san-pham',
    isCommingSoon: false,
    hasMegaMenu: true,
  },
  {
    title: (t: (key: string) => string) => t('VỀ HYDRA'),
    href: '/about',
    isCommingSoon: false,
  },
  {
    title: (t: (key: string) => string) => 'STYLING',
    href: '/styling',
    isCommingSoon: false,
  },
]
type Props = {
  categories: ICategoryMenu | null | undefined
}

export const MainBar = ({ categories }: Props) => {
  const [openMegaMenu, setOpenMegaMenu] = useState(false)
  const t = useTranslations()
  const pathname = usePathname()
  const handleMouseEnterLink = (hasMenu?: boolean) => {
    if (hasMenu) {
      setOpenMegaMenu(true)
    } else {
      setOpenMegaMenu(false)
    }
  }
  const handleMouseLeaveHeader = () => {
    setOpenMegaMenu(false)
  }
  useEffect(() => {
    setOpenMegaMenu(false)
  }, [pathname])
  return (
    <Box
      sx={{
        height: 'var(--size-hd-nav)',
        display: 'flex',
        alignItems: 'center',
        transition: 'height 0.3s ease',
        color: '#000',
        position: 'relative',
      }}
      onMouseLeave={handleMouseLeaveHeader}
    >
      <ContainerCustom component={'div'}>
        <Stack direction="row" justifyContent="space-between" spacing={2} alignItems={'center'}>
          {/* Left Menu */}
          <Stack
            direction="row"
            gap={{ lg: 2, xs: 1 }}
            sx={{ display: { xs: 'none', lg: 'flex' }, flex: 1 }}
            justifyContent={'flex-start'}
            alignItems="flex-end"
          >
            {LEFT_MENU_ITEMS.map((item, index) => {
              return (
                <Stack
                  key={item.href + index.toString()}
                  alignItems="left"
                  onMouseEnter={() => handleMouseEnterLink(item.hasMegaMenu)}
                >
                  {item.isCommingSoon && (
                    <Typography
                      p={0.5}
                      lineHeight={1}
                      borderRadius={9999}
                      color={'primary.contrastText'}
                      bgcolor="four.main"
                      display={'flex'}
                      alignItems={'center'}
                      width={'fit-content'}
                      gap={0.25}
                      fontSize={'0.7rem'}
                    >
                      <QueryBuilderOutlinedIcon fontSize="inherit" /> <span>Sắp ra mắt</span>
                    </Typography>
                  )}
                  <Typography
                    key={item.href + index.toString()}
                    component={'p'}
                    variant="body2"
                    color="inherit"
                    sx={{
                      fontWeight: 600,
                      paddingY: '2px',
                      cursor: 'pointer',
                      transition: 'border-color 0.3s ease',
                      borderBottom: '1px solid transparent',
                      '&:hover': { borderColor: 'inherit' },
                    }}
                  >
                    <Link
                      href={item.isCommingSoon ? '#' : item.href}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      {' '}
                      {item.title(t)}{' '}
                    </Link>
                  </Typography>
                </Stack>
              )
            })}
            <MegaMenuMainBar open={openMegaMenu} categories={categories} />
          </Stack>
          <Box sx={{ marginLeft: '0!important' }}>
            <NavMenuMobile menuItems={MENU_MOBILE(t)} disableTranslations={true} categories={categories} />
          </Box>
          <Stack className="hd-logo" direction={'row'} sx={{ marginLeft: { xs: '0!important', lg: 2 } }}>
            {/* Logo */}
            <Logo />
          </Stack>
          {/* Search  */}
          <Stack
            direction="row"
            spacing={{ xs: 0, sm: 1 }}
            alignItems={'center'}
            justifyContent={'end'}
            sx={{ flex: 1 }}
          >
            {/* <Suspense>
              <SearchBar />
            </Suspense> */}
            {/*Link to redirect to coming soon page */}
            {/* <WishlistHeader /> */}
            {/* <ButtonAffiliate /> */}

            <PopupFormOrderLookup isMobile={false} isDesktop={true} />

            <CartHeader />
            <UserLogin />
          </Stack>
        </Stack>
      </ContainerCustom>
    </Box>
  )
}
